import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/settings-menus.scss";
import { Link } from "react-router";

export const AccountSettingsMenu = ({ slug, vip }) => (
  <div className={ styles.menu }>
    <ul>
      { renderMenuLinks(slug, "usage", "Account Usage") }
      { renderMenuLinks(slug, "mail-in", "Mail-in Settings") }
      { renderMenuLinks(slug, "tax", "Currency, Tax and Language Settings") }
      { renderForNonVip(vip, slug, "billing-details", "Billing Settings") }
      { renderForNonVip(vip, slug, "billing-history", "Billing History") }
      { renderForNonVip(vip, slug, "subscription", "Subscription Settings") }
      { renderMenuLinks(slug, "name", "Account Name and Submission Email") }
      { renderForNonVip(vip, slug, "users", "Account Users") }
    </ul>
  </div>
);

AccountSettingsMenu.propTypes = {
  slug: PropTypes.string.isRequired,
  vip: PropTypes.bool.isRequired
};

const renderMenuLinks = (slug, path, title) => (
  <Link
    activeClassName={ styles["active-menu-item"] }
    to={ `/accounts/${slug}/settings/account/${path}` }
  >
    <li>{ title }</li>
  </Link>
);

const renderForNonVip = (vip, slug, path, title) => {
  if (vip) {
    return null;
  }
  return renderMenuLinks(slug, path, title);
};



// WEBPACK FOOTER //
// ./src/js/components/settings/account-settings-menu.jsx